
import config from './rollbar.config';

// @ts-expect-error window is not a constructor
export const rollbar: Rollbar | null = (window && window["rollbar"] && window["rollbarIgnore"]) ? new window["rollbar"](config) : null;
